unit MaBst;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer, WebBasis2, Vcl.Menus, WEBLib.Menus   ;

type
  TfrmMaBst = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    tabMaBst: TXDataWebDataSet;
    tabMaBstID_MA_BST: TIntegerField;
    tabMaBstREF_NR: TStringField;
    tabMaBstDATUM: TStringField;
    tabMaBstSTANDORT: TStringField;
    tabMaBstFARBE: TStringField;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    dtSchaden: TDateTimePicker;
    cbxFilterDatum: TCheckBox;
    tabMaBstBEZEICHNUNG: TStringField;
    tabMaBstSTATUS: TStringField;
    btnIns: TTMSFNCToolBarButton;
     //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure ErzeugeItems; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnInsClick(Sender: TObject); async;
    [async] procedure respGridItemDblClick(Sender: TObject; Index: Integer); async;
     //
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);

    procedure lbTauClick(Sender: TObject);
    procedure dtSchadenChange(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);


  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmMaBst: TfrmMaBst;

const cForm = 'MABST_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul , GetStammdaten, MaBstEdit;

//====================================================================================================================//

procedure TfrmMaBst.btnInsClick(Sender: TObject);
var aResult : TModalResult;
    iNewID : Integer;
begin
  inherited;

  Opt_Speichern;

  iNewID := 0;

  await(  DoMaBstEdit( iNewID  ) );
        //console.log('iNewID: '+  IntToStr(iNewID) )  ;
  iID_Akt := iNewID;
        //console.log('iID_Akt: '+  IntToStr(iID_Akt) )  ;
  await( Daten_Laden( iNewID ) );

end;

//====================================================================================================================//

procedure TfrmMaBst.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabMaBst.FieldByName('ID_MA_BST').AsInteger;
  Daten_Laden(iID);

  //console.Log('1 '+ IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmMaBst.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  cbxFilterDatum.Checked := SToB( TLocalStorage.GetValue( cForm+'DATUM_FILTER_EIN' ) );

  sDat := TLocalStorage.GetValue( cForm+'DATUM_FILTER' );
  If sDat='' then
       dtSchaden.DateTime := Date
  Else dtSchaden.DateTime := StrToDateTime(sDat);

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cForm+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cForm+'REC_VON' );
  sBis := TLocalStorage.GetValue( cForm+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmMaBst.Opt_Speichern;
var sAbf : String;
begin

  sAbf := DateTimeToStr( Trunc( dtSchaden.DateTime )   );

  TLocalStorage.SetValue( cForm+'DATUM_FILTER_EIN', BToS( cbxFilterDatum.Checked ));
  TLocalStorage.SetValue( cForm+'DATUM_FILTER', sAbf );

  TLocalStorage.SetValue( cForm+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cForm+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cForm+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmMaBst.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sTauStati, sKopfZeile: String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

    // Material-Bestellungen ermitteln
    //
    sSQL := '01:SELECT ID_MA_BST, REF_NR, DATUM, BEZEICHNUNG, '
           +'  (SELECT A.NAME1 FROM STANDORT S, ADRESSE A WHERE S.ID_ADRESSE=A.ID_ADRESSE AND S.ID_STANDORT=B.ID_STANDORT) as STANDORT, '
           +'  (SELECT FARBE FROM STATUS ST WHERE ST.ID_STATUS=B.ID_STATUS) as FARBE, '
           +'  (SELECT BEZEICHNUNG FROM STATUS S WHERE S.ID_STATUS=B.ID_STATUS) as STATUS '
           +' FROM MA_BST B WHERE B.ID_MITARBEITER='+ frmMainForm.BenutzerMaNr ;

    If cbxFilterDatum.Checked then
      Begin
        dtAbf := Trunc(dtSchaden.DateTime);
        sSQL := sSQL +' AND B.DATUM >= '+cH+FormatDateTime('dd.mm.yyyy',dtAbf)+cH
                     +' AND B.DATUM < ' +cH+FormatDateTime('dd.mm.yyyy',dtAbf+1)+cH;
      End;

    sSQL := sSQL + ' ORDER BY B.DATUM DESC ' +';'  ;

    sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  tabMaBst.Close;
  tabMaBst.Open;

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];
          tabMaBst.Append;
            tabMaBst.FieldByName('ID_MA_BST').AsInteger := SToI(GetFeldWert( sFelder, sDaten, 'ID_MA_BST' ));
            tabMaBst.FieldByName('REF_NR').AsString   := GetFeldWert( sFelder, sDaten, 'REF_NR'  );
            tabMaBst.FieldByName('DATUM').AsString    := GetFeldWert( sFelder, sDaten, 'DATUM'   );
            tabMaBst.FieldByName('STANDORT').AsString := GetFeldWert( sFelder, sDaten, 'STANDORT' );
            tabMaBst.FieldByName('STATUS').AsString   := GetFeldWert( sFelder, sDaten, 'STATUS' );
            tabMaBst.FieldByName('BEZEICHNUNG').AsString := GetFeldWert( sFelder, sDaten, 'BEZEICHNUNG' );

            sTmp :=  GetFeldWert( sFelder, sDaten, 'FARBE' );
            If sTmp = '' then sTmp := '$00DFFFFF';
            tabMaBst.FieldByName('FARBE').AsString := sTmp;

          tabMaBst.Post;
        End;
    End;

  aSL.Free;
  aSL_Daten.Free;

  If aID = 0 then tabMaBst.First;
  If aID > 0 then
    If not tabMaBst.Locate('ID_MA_BST',aID,[]) then tabMaBst.First;

  btnNavNext.Enabled := (tabMaBst.RecordCount=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  ErzeugeItems;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmMaBst.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmMaBst.dtSchadenChange(Sender: TObject);
var iID : Integer;
begin

  If (Sender=dtSchaden) and (cbxFilterDatum.Checked=False) then Exit;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabMaBst.FieldByName('ID_MA_BST').AsInteger;

  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmMaBst.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmMaBst.WebFormCreate(Sender: TObject);
begin

  Inherited;

  //Console.Log('WebFormCreate----'+IntToStr( frmMainForm.g_RecAnzahl)) ;

  bFirst := False;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;
  btnIns.BitmapContainer := frmMainForm.BitmapCont;

  If Application.IsMobile then
       dtSchaden.Width := 95
  Else dtSchaden.Width := 130;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmMaBst.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmMaBst.ErzeugeItems;
var aItem : TResponsiveGridItem;
    sText : String;
    aColBG, aColVG : TColor;
begin

  respGrid.Items.Clear;

  tabMaBst.First;
  While not tabMaBst.eof Do
    Begin
      aColBG := StringToColor( tabMaBstFARBE.AsString );
      aColVG := GetSchriftFarbe( aColBG );

//      sText := '<p><strong>'+tabMaBstDATUM.AsString+'</strong> - '+tabMaBstREF_NR.AsString+'<br />'
//       +tabMaBstSTANDORT.AsString+' - '+tabMaBstSTATUS.AsString+'<br />'+tabMaBstBEZEICHNUNG.AsString+'<br /><br /></p>';

      sText := '<p><strong>'+tabMaBstDATUM.AsString+'</strong> - '+tabMaBstREF_NR.AsString +' - ' //+'<br />'

     +'<span style="background-color: '+ColToHtmlCol(aColBG)+'; color: '+ColToHtmlCol(aColVG)+';">'+tabMaBstSTATUS.AsString +'</span><br />'

       +tabMaBstSTANDORT.AsString+'<br />'+Copy(tabMaBstBEZEICHNUNG.AsString,1,40)+'<br /><br /></p>';



      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  tabMaBstID_MA_BST.AsInteger;

      //console.log( inttostr(self.iID_Akt)+' - '+inttostr(tabMaBstID_MA_BST.AsInteger) );

      If tabMaBstID_MA_BST.AsInteger = self.iID_Akt then
        Begin
          //Console.Log('iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

     tabMaBst.Next;

    end;

end;

procedure TfrmMaBst.lbTauClick(Sender: TObject);
begin
// Showmessage( lbMitarbeiter.font.Name );
end;

//====================================================================================================================//

procedure TfrmMaBst.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;
    iID_MaBst : Integer;
begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  iID_MaBst  := aItem.Tag;

  await( DoMaBstEdit( iID_MaBst ) );

  await( Daten_Laden( iID_MaBst ) );


end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmMaBst.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTau -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmTau');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmTau3: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmMaBst.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  dtSchaden := TDateTimePicker.Create(Self);
  cbxFilterDatum := TCheckBox.Create(Self);
  btnIns := TTMSFNCToolBarButton.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabMaBst := TXDataWebDataSet.Create(Self);
  tabMaBstREF_NR := TStringField.Create(Self);
  tabMaBstDATUM := TStringField.Create(Self);
  tabMaBstBEZEICHNUNG := TStringField.Create(Self);
  tabMaBstSTANDORT := TStringField.Create(Self);
  tabMaBstSTATUS := TStringField.Create(Self);
  tabMaBstID_MA_BST := TIntegerField.Create(Self);
  tabMaBstFARBE := TStringField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  dtSchaden.BeforeLoadDFMValues;
  cbxFilterDatum.BeforeLoadDFMValues;
  btnIns.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabMaBst.BeforeLoadDFMValues;
  tabMaBstREF_NR.BeforeLoadDFMValues;
  tabMaBstDATUM.BeforeLoadDFMValues;
  tabMaBstBEZEICHNUNG.BeforeLoadDFMValues;
  tabMaBstSTANDORT.BeforeLoadDFMValues;
  tabMaBstSTATUS.BeforeLoadDFMValues;
  tabMaBstID_MA_BST.BeforeLoadDFMValues;
  tabMaBstFARBE.BeforeLoadDFMValues;
  try
    Width := 1137;
    Height := 515;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1137;
    WebPanel1.Height := 90;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 16;
    lbTau.Top := 8;
    lbTau.Width := 192;
    lbTau.Height := 18;
    lbTau.Caption := 'Material-Bestellungen';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 1;
    btnNavPrev.Top := 34;
    btnNavPrev.Width := 60;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 163;
    btnNavNext.Top := 34;
    btnNavNext.Width := 60;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 62;
    btnNavInfo.Top := 34;
    btnNavInfo.Width := 99;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    dtSchaden.SetParentComponent(WebPanel1);
    dtSchaden.Name := 'dtSchaden';
    dtSchaden.Left := 277;
    dtSchaden.Top := 34;
    dtSchaden.Width := 110;
    dtSchaden.Height := 44;
    dtSchaden.Cursor := crHandPoint;
    dtSchaden.BorderStyle := bsSingle;
    dtSchaden.ChildOrder := 5;
    dtSchaden.Color := 15329769;
    dtSchaden.Date := 45767.262767685180000000;
    dtSchaden.Role := '';
    dtSchaden.ShowSeconds := False;
    dtSchaden.Text := '';
    SetEvent(dtSchaden, Self, 'OnChange', 'dtSchadenChange');
    cbxFilterDatum.SetParentComponent(WebPanel1);
    cbxFilterDatum.Name := 'cbxFilterDatum';
    cbxFilterDatum.Left := 282;
    cbxFilterDatum.Top := 0;
    cbxFilterDatum.Width := 105;
    cbxFilterDatum.Height := 33;
    cbxFilterDatum.Cursor := crHandPoint;
    cbxFilterDatum.Caption := 'Datum';
    cbxFilterDatum.ChildOrder := 6;
    cbxFilterDatum.HeightPercent := 100.000000000000000000;
    cbxFilterDatum.WidthPercent := 100.000000000000000000;
    SetEvent(cbxFilterDatum, Self, 'OnClick', 'dtSchadenChange');
    btnIns.SetParentComponent(WebPanel1);
    btnIns.Name := 'btnIns';
    btnIns.Left := 225;
    btnIns.Top := 34;
    btnIns.Width := 50;
    btnIns.Height := 44;
    btnIns.Cursor := crHandPoint;
    btnIns.ParentDoubleBuffered := False;
    btnIns.DoubleBuffered := True;
    btnIns.Font.Charset := DEFAULT_CHARSET;
    btnIns.Font.Color := clWindowText;
    btnIns.Font.Height := -11;
    btnIns.Font.Name := 'Segoe UI';
    btnIns.Font.Style := [];
    btnIns.ParentColor := True;
    btnIns.TabOrder := 5;
    SetEvent(btnIns, Self, 'OnClick', 'btnInsClick');
    btnIns.Text := '';
    btnIns.Bitmaps.Clear;
    with btnIns.Bitmaps.Add do
    begin
      BitmapName := 'INS';
    end;
    btnIns.BitmapVisible := True;
    btnIns.BitmapContainer := BitmapCont;
    btnIns.ControlIndex := 0;
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 90;
    respGrid.Width := 1137;
    respGrid.Height := 425;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 70;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 5;
    respGrid.Options.ItemWidthMin := 280;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 567;
    BitmapCont.Top := 8;
    tabSprachDaten.Left := 96;
    tabSprachDaten.Top := 104;
    tabMaBst.SetParentComponent(Self);
    tabMaBst.Name := 'tabMaBst';
    tabMaBst.Left := 104;
    tabMaBst.Top := 216;
    tabMaBstREF_NR.SetParentComponent(tabMaBst);
    tabMaBstREF_NR.Name := 'tabMaBstREF_NR';
    tabMaBstREF_NR.Alignment := taCenter;
    tabMaBstREF_NR.DisplayLabel := 'Bestell-Nr';
    tabMaBstREF_NR.DisplayWidth := 12;
    tabMaBstREF_NR.FieldName := 'REF_NR';
    tabMaBstREF_NR.Required := True;
    tabMaBstREF_NR.Size := 15;
    tabMaBstDATUM.SetParentComponent(tabMaBst);
    tabMaBstDATUM.Name := 'tabMaBstDATUM';
    tabMaBstDATUM.Alignment := taCenter;
    tabMaBstDATUM.DisplayLabel := 'Datum';
    tabMaBstDATUM.FieldName := 'DATUM';
    tabMaBstDATUM.Size := 10;
    tabMaBstBEZEICHNUNG.SetParentComponent(tabMaBst);
    tabMaBstBEZEICHNUNG.Name := 'tabMaBstBEZEICHNUNG';
    tabMaBstBEZEICHNUNG.DisplayLabel := 'Bezeichnung';
    tabMaBstBEZEICHNUNG.FieldName := 'BEZEICHNUNG';
    tabMaBstBEZEICHNUNG.Size := 200;
    tabMaBstSTANDORT.SetParentComponent(tabMaBst);
    tabMaBstSTANDORT.Name := 'tabMaBstSTANDORT';
    tabMaBstSTANDORT.Alignment := taCenter;
    tabMaBstSTANDORT.DisplayLabel := 'Zeit';
    tabMaBstSTANDORT.DisplayWidth := 25;
    tabMaBstSTANDORT.FieldName := 'STANDORT';
    tabMaBstSTANDORT.Size := 200;
    tabMaBstSTATUS.SetParentComponent(tabMaBst);
    tabMaBstSTATUS.Name := 'tabMaBstSTATUS';
    tabMaBstSTATUS.FieldName := 'STATUS';
    tabMaBstSTATUS.Size := 50;
    tabMaBstID_MA_BST.SetParentComponent(tabMaBst);
    tabMaBstID_MA_BST.Name := 'tabMaBstID_MA_BST';
    tabMaBstID_MA_BST.Alignment := taCenter;
    tabMaBstID_MA_BST.DisplayWidth := 6;
    tabMaBstID_MA_BST.FieldName := 'ID_MA_BST';
    tabMaBstID_MA_BST.Required := True;
    tabMaBstFARBE.SetParentComponent(tabMaBst);
    tabMaBstFARBE.Name := 'tabMaBstFARBE';
    tabMaBstFARBE.FieldName := 'FARBE';
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    dtSchaden.AfterLoadDFMValues;
    cbxFilterDatum.AfterLoadDFMValues;
    btnIns.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabMaBst.AfterLoadDFMValues;
    tabMaBstREF_NR.AfterLoadDFMValues;
    tabMaBstDATUM.AfterLoadDFMValues;
    tabMaBstBEZEICHNUNG.AfterLoadDFMValues;
    tabMaBstSTANDORT.AfterLoadDFMValues;
    tabMaBstSTATUS.AfterLoadDFMValues;
    tabMaBstID_MA_BST.AfterLoadDFMValues;
    tabMaBstFARBE.AfterLoadDFMValues;
  end;
end;

end.

